
import {Options, Vue} from "vue-class-component";

@Options({
           components: {},
           props:      {},
         })
export default class SoundWave extends Vue
{
  declare $refs: {
    canvas: HTMLCanvasElement
  }
  analyzer: any;
  audioContext: any;
  audioSource: any;
  ctx?: CanvasRenderingContext2D | null;
  frequencyData: Uint8Array | undefined;
  hertzMultiplier: Number | undefined;
  shouldDraw: Boolean = false;
  fctOnResize!: any;
  canListenToPlayback: Boolean = false;
  audioPlayback: any;
  disconnected: Boolean = false;

  get canvas()
  {
    return this.$refs.canvas;
  }

  get drawOptions()
  {
    //We need to draw the effects 3 times.
    //Theses are the settigs to draw them
    return [
      {
        min:   50,
        max:   3000,
        color: {r: 255, g: 255, b: 235, a: 0.15},

        radius: 210,
        points: 40
      },
      {
        min:   1250,
        max:   1800,
        color: {r: 115, g: 166, b: 152, a: 0.04},

        radius: 190,
        points: 32
      },
      {
        min:   2250,
        max:   2400,
        color: {r: 0, g: 166, b: 118, a: 0.03},

        radius: 170,
        points: 32
      }
    ]
  }

  prepareApp(bShouldDraw: boolean = true)
  {
    this.createContext();

    this.shouldDraw = bShouldDraw;
    this.fctOnResize = this.resizeCanvas.bind(this);
    window.addEventListener("resize", this.fctOnResize);

    setTimeout(() =>
               {
                 this.fctOnResize();
                 this.draw();
               }, 2);
  }

  //this is more complicated than expected
  // startCanUsePlaybackButton (audio: any)
  // {
  //     let htmlAudio = document.createElement('audio');
  //     htmlAudio.srcObject = audio;
  //     this.audioPlayback = htmlAudio;
  //     this.canListenToPlayback = true;
  // }
  //
  // startPlayback ()
  // {
  //     this.createAudioContext(this.audioPlayback);
  // }

  prepareReactiveSoundWave(audio: any, bDraw: boolean = true)
  {

     this.createAudioContext(audio);
    // this.prepareApp(bDraw);

  }

  createAudioContext(audio: any)
  {
    let audioContext = this.audioContext = new AudioContext();


    //when recording, we will receive a MediaStream, other just an Audio
    let source = this.audioSource = audio instanceof MediaStream ? audioContext.createMediaStreamSource(audio) : audioContext.createMediaElementSource(audio);


    this.analyzer = audioContext.createAnalyser();
    this.analyzer.fftSize = 2048 * 16; //read the actual rate on the audio

    if (audio instanceof Audio)
    {
      //When connecting with analyzer with microphone we get a feedback loop
      this.analyzer.connect(audioContext.destination);

    }

    this.frequencyData = new Uint8Array(this.analyzer.frequencyBinCount);
    source.connect(this.analyzer);


    if (!(audio instanceof MediaStream))
    {
      // let volume = audioContext.createGain();
      //
      // source.connect(volume);
      // volume.connect(this.analyzer);
      // volume.gain.value = 0;
    }

    this.hertzMultiplier = audioContext.sampleRate / this.analyzer.fftSize;
  }

  destroy ()
  {
    this.removeContext();
    this.stopDraw();
  }

  removeContext ()
  {
    if (this.disconnected || !this.audioSource)
      return;

    if (this.audioSource instanceof Audio)
    {
      this.analyzer.disconnect(this.audioContext.destination);
    }

    this.audioSource.disconnect(this.analyzer);

    this.disconnected = true;
  }

  createContext()
  {
    this.ctx = this.canvas.getContext("2d");
  }

  resizeCanvas()
  {
    this.canvas.width = this.canvas.clientWidth;
    this.canvas.height = this.canvas.clientHeight;
  }

  stopDraw()
  {
    this.shouldDraw = false;
    window.removeEventListener("resize", this.fctOnResize)
  }

  setCanDraw(bShouldDraw: boolean, bStartDraw: boolean = true)
  {
    this.shouldDraw = bShouldDraw;

    if (bShouldDraw && bStartDraw)
    {
      this.draw();
    }
  }

  draw()
  {
    if (!this.shouldDraw)
    {
      return;
    }

    requestAnimationFrame(() => this.draw());

    if (this.analyzer)
    {
      this.analyzer.getByteFrequencyData(this.frequencyData);
    }

    this.drawLayers();


  }

  drawLayers()
  {
    this.clear();

    for (let i = 0; i < 3; i++)
    {
      this.drawOne(i, this.frequencyData)
    }
  }

  drawOne(index: any, frequencies: any)
  {

    let options = this.drawOptions[index];

    let ptCenter = this.getCenter();
    let size = this.getCanvasSize();
    let ratio = size.w / 800; //we expected the canvas to be 800, if not we need to adjust the radius

    let arrFreq = this.getFrequencyDomainRange(frequencies, options, this.hertzMultiplier);
    let arrAvg = this.getAverageFrequency(arrFreq, options)
    let arrPts = this.getCircularPoint(arrAvg, options.radius * ratio, ptCenter);

    if (this.ctx)
    {
      this.ctx.beginPath();
      this.ctx.fillStyle = `rgba(${options.color.r},${options.color.g},${options.color.b},${options.color.a})`


      for (let i = 0; i < arrPts.length; i++)
      {
        let pt = arrPts[i];
        if (i === 0)
        {
          this.ctx.moveTo(pt.x, pt.y)
        }
        else
        {
          this.ctx.lineTo(pt.x, pt.y)
        }

      }
      let pt = arrPts[0];
      this.ctx.lineTo(pt.x, pt.y)

      this.ctx.fill();
    }

  }


  getCanvasSize()
  {
    let w = this.canvas.clientWidth;
    let h = this.canvas.clientHeight;

    return {w, h};
  }


  //**************************
  //DRAWING METHODS
  getCircularPoint(arrFreq: any, radius: any, ptCenter: any)
  {
    let offsetAngle = 360 / arrFreq.length;
    let TO_RAD = Math.PI / 180;

    let arrPt = [];

    for (let i = 0; i < arrFreq.length; i++)
    {
      let degAngle = (i * offsetAngle)
      let angle = degAngle * TO_RAD;
      let radiusFreq = radius + (arrFreq[i] * radius);

      let x = ptCenter.x + (Math.sin(angle) * radiusFreq);
      let y = ptCenter.y + (Math.cos(angle) * radiusFreq);

      arrPt.push({x, y});
    }

    return arrPt;
  }

  getFrequencyDomainRange(frequency: any, options: any, hertzMultiplier: any)
  {
    if (!frequency)
    {
      let arr = [];
      for (let i = 0 ; i < 360; i++)
      {
        arr[i] = 0;
      }

      return arr;
    }

    let arrData = Array.from(frequency);
    arrData = arrData.filter((f, i) => (i * hertzMultiplier >= options.min) && (i * hertzMultiplier < options.max))

    return arrData;
  }

  getCenter()
  {
    let size = this.getCanvasSize();
    return {x: size.w / 2, y: size.h / 2};
  }

  getAverageFrequency(frequency: any, options: any, multiplier: any = 1)
  {
    let count = options.points;
    let groupCount = (frequency.length / count) >> 0; //how many item in group to average

    let arrGrouped = frequency.reduce((arr: any, freq: any, index: any) =>
                                      {
                                        let groupIndex = (index / groupCount) >> 0;

                                        if (!Array.isArray(arr[groupIndex]))
                                        {
                                          arr[groupIndex] = [];
                                        }

                                        arr[groupIndex].push(freq);

                                        return arr;
                                      }, [])


    let arrGroupedAvg = arrGrouped.map((arrGroup: any) => arrGroup.reduce(((sum: any, freq: any) => sum + freq), 0) / arrGroup.length);
    let arrNormalize = arrGroupedAvg.map((freqAvg: any) => (freqAvg / 255) * multiplier)
                                    .map((row: any, index: any, arr: any) =>
                                         {
                                           let i1 = index - 1;
                                           let i2 = index;
                                           let i3 = index + 1;

                                           if (i1 < 0)
                                           {
                                             i1 = arr.length - 1;
                                           }

                                           if (i3 >= arr.length)
                                           {
                                             i3 = 0;
                                           }

                                           let sum = arr[i1] + arr[i2] + arr[i3];
                                           let avg = sum / 3;

                                           return avg;
                                         });

    return arrNormalize;

  }


  clear()
  {
    if (this.ctx)
    {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
  }

  unmounted()
  {
    this.audioPlayback = null;
    this.canListenToPlayback = false;

    this.removeContext();
    this.stopDraw();


  }
}
